export function getFullName(firstName?: string, lastName?: string) {
  const first = (firstName || "").trim();
  const last = (lastName || "").trim();
  return first && last ? `${first} ${last}` : `${first}${last}`;
}
